import { Box, Paper } from '@mui/material';
import { AppLogo, Login, ThemeToggle } from 'components';

export const PublicLogin = () => {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
            <Box sx={{ position: 'fixed', top: 8, right: 8 }}>
                <ThemeToggle />
            </Box>
            <Paper className="aq-content" sx={{ boxShadow: 'none' }}>
                <div className="login-header">
                    <AppLogo fontSize="1.5em" />
                </div>
                <Login />
            </Paper>
        </Box>
    );
};
